import { render, staticRenderFns } from "./dict-jurnal.vue?vue&type=template&id=0be52fe8&scoped=true&"
import script from "./dict-jurnal.vue?vue&type=script&lang=ts&"
export * from "./dict-jurnal.vue?vue&type=script&lang=ts&"
import style0 from "./dict-jurnal.vue?vue&type=style&index=0&id=0be52fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be52fe8",
  null
  
)

export default component.exports